import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import useCreateNewOffice from "Pages/Admin/Users/@hooks/useCreateNewOffice"
import React from "react"
import { useComputed } from "@preact/signals-react"
import { isValidNewOffice } from "Pages/Admin/Users/@signals"

export default function SubmitNewOffice() {

	const { onSubmit, isLoading } = useCreateNewOffice()
	const hasErrors = useComputed(() => Object.values(isValidNewOffice.value).some(e => !e))

	return <ButtonLoadingSeeker
		loading={isLoading}
		onClick={onSubmit}
		startIcon={<IconSeeker icon="floppy-disk"/>}
		disabled={hasErrors.value}
	>
		Create Office
	</ButtonLoadingSeeker>
}